export const DEMO_PENDING_TABLE = [
  {
    leadId: 1,
    leadName: 'ABCD',
    createdOn: '25/09/2021',
    assignedTo: 'BCDA',
    branch: 'X School',
    formId: 'A12',
    class: '5th',
    formSubmissionDate: '12/01/2021',
    status: 'Converted',
    parentid: '12341',
    rating: '****',
  },
  {
    leadId: 2,
    leadName: 'IUOQWE',
    createdOn: '26/09/2021',
    assignedTo: 'ASD',
    branch: 'Y School',
    formId: 'B12',
    class: '6th',
    formSubmissionDate: '12/01/2021',
    status: 'Converted',
    parentid: '12342',
    rating: '*',
  },
  {
    leadId: 3,
    leadName: 'QWE',
    createdOn: '25/09/2021',
    assignedTo: 'WE',
    branch: 'X School',
    formId: 'C12',
    class: '4th',
    formSubmissionDate: '12/01/2021',
    status: 'Converted',
    parentid: '12343',
    rating: '**',
  },
  {
    leadId: 4,
    leadName: 'ZX',
    createdOn: '25/09/2021',
    assignedTo: 'NGH',
    branch: 'Y School',
    formId: 'D12',
    class: '6th',
    formSubmissionDate: '12/01/2021',
    status: 'Converted',
    parentid: '12344',
    rating: '*****',
  },
  {
    leadId: 5,
    leadName: 'QWEAD',
    createdOn: '25/09/2021',
    assignedTo: 'ZXCAS',
    branch: 'X School',
    formId: 'X12',
    class: '5th',
    formSubmissionDate: '12/01/2021',
    status: 'Converted',
    parentid: '12345',
    rating: '***',
  },
  {
    leadId: 6,
    leadName: 'GKJ',
    createdOn: '25/09/2021',
    assignedTo: 'BNM',
    branch: 'X School',
    formId: 'B22',
    class: '5th',
    formSubmissionDate: '12/01/2021',
    status: 'Converted',
    parentid: '12346',
    rating: '*****',
  },
];

export const DEMO_PENDING_TABLE2 = [
  {
    leadId: 1,
    leadName: 'ABCD',
    createdOn: '25/09/2021',
    assignedTo: 'BCDA',
    branch: 'X School',
    formId: 'A12',
    class: '5th',
    formSubmissionDate: '12/01/2021',
    phone: '1234567890',
    emailid: 'abc@gmail.com',
    rating: '****',
  },
  {
    leadId: 2,
    leadName: 'IUOQWE',
    createdOn: '26/09/2021',
    assignedTo: 'ASD',
    branch: 'Y School',
    formId: 'B12',
    class: '6th',
    formSubmissionDate: '12/01/2021',
    phone: '8794567890',
    emailid: 'abcd@gmail.com',
    rating: '*',
  },
  {
    leadId: 3,
    leadName: 'QWE',
    createdOn: '25/09/2021',
    assignedTo: 'WE',
    branch: 'X School',
    formId: 'C12',
    class: '4th',
    formSubmissionDate: '12/01/2021',
    phone: '1235467890',
    emailid: 'ab@gmail.com',
    rating: '**',
  },
  {
    leadId: 4,
    leadName: 'ZX',
    createdOn: '25/09/2021',
    assignedTo: 'NGH',
    branch: 'Y School',
    formId: 'D12',
    class: '6th',
    formSubmissionDate: '12/01/2021',
    phone: '1234567123',
    emailid: 'abc4@gmail.com',
    rating: '*****',
  },
  {
    leadId: 5,
    leadName: 'QWEAD',
    createdOn: '25/09/2021',
    assignedTo: 'ZXCAS',
    branch: 'X School',
    formId: 'X12',
    class: '5th',
    formSubmissionDate: '12/01/2021',
    phone: '1231237890',
    emailid: 'abc2@gmail.com',
    rating: '***',
  },
  {
    leadId: 6,
    leadName: 'GKJ',
    createdOn: '25/09/2021',
    assignedTo: 'BNM',
    branch: 'X School',
    formId: 'B22',
    class: '5th',
    formSubmissionDate: '12/01/2021',
    phone: '1234567890',
    emailid: 'abc@gmail.com',
    rating: '*****',
  },
];

export const DEMO_ARCHIVE_TABLE = [
  {
    leadId: 1,
    leadName: 'ABCD',
    createdOn: '25/09/2021',
    assignedTo: 'BCDA',
    branch: 'X School',
    formId: 'A12',
    class: '5th',
    formSubmissionDate: '12/01/2021',
    status: 'Converted',
  },
  {
    leadId: 2,
    leadName: 'IUOQWE',
    createdOn: '26/09/2021',
    assignedTo: 'ASD',
    branch: 'Y School',
    formId: 'B12',
    class: '6th',
    formSubmissionDate: '12/01/2021',
    status: 'Converted',
  },
  {
    leadId: 3,
    leadName: 'QWE',
    createdOn: '25/09/2021',
    assignedTo: 'WE',
    branch: 'X School',
    formId: 'C12',
    class: '4th',
    formSubmissionDate: '12/01/2021',
    status: 'Converted',
  },
];
